import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import config from 'config';
import metrics from 'lib/common/metrics';
import { calculateTotal, toCurrency } from 'services/Pricer';
import LineItem from 'components/LineItem';
import { ERROR_CONSTANTS } from 'constants';
import { IconChevronUp, IconChevronDown } from 'components/Icons';
import features from '../lib/common/features';

const Basket = React.createClass({
  propTypes: {
    lineItems: PropTypes.array,
    isProcessing: PropTypes.bool,
    prices: PropTypes.array,
    noticeMessage: PropTypes.string,
    buttonLabel: PropTypes.string.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    handleRemoval: PropTypes.func.isRequired,
    handleReselection: PropTypes.func.isRequired,
    handlePriceTypeChange: PropTypes.func.isRequired,
    isBookButtonDisabled: PropTypes.bool,
    isExchange: PropTypes.bool,
    isUpgrade: PropTypes.bool,
    exchangeItemsAmount: PropTypes.number,
    exchangePriceTypes: PropTypes.array
  },
  getInitialState: function() {
    // Default to closed on small screens, open on large screens.
    return {
      isOpen:
        window.matchMedia && window.matchMedia('(min-width: 40em)').matches
          ? true
          : false
    };
  },
  handleToggle: function() {
    this.setState(
      prevState => {
        return {
          isOpen: !prevState.isOpen
        };
      },
      () => {
        metrics.action('Toggle cart', this.state.isOpen ? 'open' : 'close');
      }
    );
  },
  renderBasicNoticeMessage: function() {
    const shouldRenderMessage =
      this.props.noticeMessage &&
      Object.keys(ERROR_CONSTANTS).indexOf(this.props.noticeMessage) == -1;

    if (shouldRenderMessage) {
      return (
        <div className="syos-basket__message">{this.props.noticeMessage}</div>
      );
    } else {
      return null;
    }
  },
  handleSubmit: function(e) {
    e.stopPropagation();
    this.props.handleSubmit();
  },
  calculatePodTicketsAmount: function(item) {
    let result = this.props.selectedPods.filter(pod => {
      if (pod.section == item.seatData.section) {
        return pod.amount;
      }
    });

    return result.length ? result[0].amount : 0;
  },
  render: function() {
    let totalToDisplay = toCurrency(
      calculateTotal(this.props.lineItems.map(x => x.priceData.price))
    );

    if (features.isEnabled('priceFees')) {
      let priceWithFees = calculateTotal(
        this.props.lineItems.map(x => x.priceData.price_with_fee)
      );

      if (priceWithFees) {
        totalToDisplay = priceWithFees;
      }
    }

    return (
      <div
        className={classnames({
          'syos-basket': true,
          'syos-basket--closed': !this.state.isOpen
        })}
      >
        {this.renderBasicNoticeMessage()}
        <div className="syos-basket__inner">
          <div className="syos-basket__header">
            <div className="syos-basket__details">
              <button
                className="syos-basket__toggle u-syos-button-reset"
                onClick={this.handleToggle}
              >
                {this.state.isOpen ? <IconChevronDown /> : <IconChevronUp />}
                <span className="syos-basket__total">
                  <span className="syos-basket__total-label">
                    {`${config.basket.totalLabel}: `}
                  </span>
                  <span className="syos-basket__total-value">
                    {totalToDisplay}
                  </span>
                </span>
              </button>
            </div>
            <div className="syos-basket__actions">
              <button
                className="syos-button"
                onClick={this.handleSubmit}
                disabled={this.props.isBookButtonDisabled}
              >
                {this.props.buttonLabel}
              </button>
            </div>
          </div>
          <div className="syos-basket__contents">
            <div className="syos-basket__selections">
              {this.props.isExchange ? (
                <p>
                  <strong>{`${Math.min(
                    this.props.lineItems.length,
                    this.props.exchangeItemsAmount
                  )} out of ${this.props.exchangeItemsAmount} seat${this.props
                    .exchangeItemsAmount > 1
                    ? 's'
                    : ''} exchanged.`}</strong>
                  <br />
                  {`${this.props.lineItems.length <
                  this.props.exchangeItemsAmount
                    ? `Add at least ${this.props.exchangeItemsAmount -
                        this.props.lineItems.length} more seat${this.props
                        .exchangeItemsAmount -
                        this.props.lineItems.length >
                      1
                        ? 's'
                        : ''} to go to the cart.`
                    : ''}`}
                </p>
              ) : null}

              <ul className="syos-basket__lineItems">
                {this.props.lineItems.map(item => {
                  const podTicketsAmount = this.calculatePodTicketsAmount(item);
                  return (
                    <li key={item.seatData.seat_no}>
                      <LineItem
                        lineItem={item}
                        prices={this.props.prices}
                        onClickRemoval={() => this.props.handleRemoval(item)}
                        onClickReselect={() =>
                          this.props.handleReselection(item)}
                        onChangeUpdatePrice={this.props.handlePriceTypeChange}
                        podTicketsAmount={podTicketsAmount}
                        isExchange={this.props.isExchange}
                      />
                    </li>
                  );
                })}
              </ul>
            </div>
            {config.basket.extraMessages.length ? (
              <div className="syos-basket__extra u-syos-note">
                {config.basket.extraMessages.map((msg, idx) => {
                  return <p key={idx}>{msg}</p>;
                })}
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
});

export default Basket;



// WEBPACK FOOTER //
// ./src/javascripts/app/components/Basket.js